import FormCodeEditor from "@babackapp/react-hook-forms-components/form-code-editor";
import { SettingsFormPageButtonBar } from "@babackapp/react-hook-forms-components/form-page";
import { Form, FormField } from "@babackapp/ui/components/form";
import { useForm } from "react-hook-form";
import { CustomCSSFormValues } from "./custom-css-card";

type CustomCSFormProps = {
  onSubmit: (value: CustomCSSFormValues) => void;
  defaultValues?: {
    customCSS?: string;
  };
};

export default function CustomCSSForm({
  defaultValues,
  onSubmit,
}: CustomCSFormProps) {
  const form = useForm<CustomCSSFormValues>({
    defaultValues: {
      customCSS:
        defaultValues?.customCSS ??
        `
/**
 * Personalize your shop with custom CSS
 * to make it look exactly the way you want.
 * and match your brand identity.
 */
`,
    },
  });

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="mt-8 flex flex-col gap-8"
      >
        <FormField
          control={form.control}
          name="customCSS"
          render={({ field }) => (
            <FormCodeEditor
              label="Custom CSS"
              language="css"
              description="Personalize your shop with custom CSS to make it look exactly the way you want and match your brand identity."
              {...field}
            />
          )}
        />
        <SettingsFormPageButtonBar />
      </form>
    </Form>
  );
}
